import React from 'react';

import { Locale } from 'date-fns';
import { enUS } from 'date-fns/locale';

interface LocaleContextType {
  locale: Locale;
}
export const LocaleContext = React.createContext<LocaleContextType>({ locale: enUS });
